module.exports = __webpack_public_path__ + "static/media/ic_ci_d1_fisdom.2d9cd3f5.svg";